import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {$AutoplayOptionsPopup} from './components/AutoplayOptionsPopup';
import {Container} from 'pixi.js';
import {uiAutoplayOptionsStore} from '@gongxigames/framework/slotV2/ui/services/UIAutoplayOptions/uiAutoplayOptionsStore';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class UIRubyAutoplayOptionsModule extends UIModuleV2 {
    static NAME = 'UIRubyAutoplayOptionsModule';
    public static layer = LAYERS.TOP;

    container = new Container();

    onInit(): void {
        const {
            showOptionsPopup,
            defaultSpins,
            autoplayValues,
            untilBonus,
            singleWin,
            winLimit,
            lossLimit,
        } = uiAutoplayOptionsStore;
                
        const uiDefault = $AutoplayOptionsPopup({
            showOptionsPopup,
            defaultSpins,
            autoplayValues,
            untilBonus,
            singleWin,
            winLimit,
            lossLimit,
            onUntilBonus: this.onUntilBonus.bind(this),
            onStartAutoplay: this.onStartAutoplay.bind(this),
            onUpdateValue: this.onUpdateValue.bind(this),
            onWinLimit: this.onWinLimit.bind(this),
            onLossLimit: this.onLossLimit.bind(this),
            onSingleWin: this.onSingleWin.bind(this),
            onCancel: this.onCancel.bind(this),
        }) as Container;

        this.container.addChild(uiDefault);
    }

    protected resetLimits(): void {
        this.emitter.emit('UI.autoplayOptions.SingleWin', null);
        this.emitter.emit('UI.autoplayOptions.WinLimit', null);
        this.emitter.emit('UI.autoplayOptions.LossLimit', null);
    }
    
    protected onCancel(): void {
        this.resetLimits();
        this.emitter.emit('UI.autoplayOptions.Close');
        slotStore.soundPlayer.value?.play('buttonclick');
    }


    protected onUntilBonus(value: boolean): void {
        this.emitter.emit('UI.autoplayOptions.UntilBonus', value);
        slotStore.soundPlayer.value?.play('buttonclick');
    }

    protected onUpdateValue(value: number): void {
        this.emitter.emit('UI.command.autoplay.changedOption', {autoplaySpins: value});
        slotStore.soundPlayer.value?.play('buttonclick');
    }

    protected onSingleWin(value: number | null): void {
        this.emitter.emit('UI.autoplayOptions.SingleWin', value);
    }

    protected onWinLimit(value: number | null): void {
        this.emitter.emit('UI.autoplayOptions.WinLimit', value);
    }

    protected onLossLimit(value: number | null): void {
        this.emitter.emit('UI.autoplayOptions.LossLimit', value);
    }

    protected onStartAutoplay(value: number): void {
        this.emitter.emit('UI.autoplayOptions.StartAutoplay', value);
        slotStore.soundPlayer.value?.play('buttonclick');
        this.resetLimits();
    }
}